'use strict';

const deliveryUtils = require('./deliveryModal/deliveryUtils');

function handleRecurringPurchaseSelection() {
    const recurringPurchaseLabel = $('.recurring-purchase-mobile-text span');
    if (!recurringPurchaseLabel.length) {
        return;
    }

    const value = $(this).val();
    const frequencyText = `${recurringPurchaseLabel.data('selected-text')} ${value}</b>`;
    recurringPurchaseLabel.html(frequencyText);
}

function resetRecurringPurchaseMobileLabel() {
    const recurringPurchaseLabel = $('.recurring-purchase-mobile-text span');
    recurringPurchaseLabel.html(recurringPurchaseLabel.data('select-text'));
}

function handleRecurringPurchaseToggle() {
    const $checkbox = $(this);
    const isChecked = $checkbox.prop('checked');
    const $frequencySelect = $('.recurring-purchase .select-container');
    const $addToCartButton = $('.product-actions .add-to-cart');
    const isCustomerLogged = $('.ua-customer-logged').length > 0 || $('#myaccount .user-message .user-name').length > 0;
    const isMobile = $('.ua-mobile').length !== 0;

    if (isChecked) {
        if (isCustomerLogged) {
            $frequencySelect.removeClass('d-none');
            $addToCartButton.text($addToCartButton.data('recurrency-text'));
        }
        else {
            //Removes check
            $checkbox.prop('checked', false).trigger("change");
            //shows modal / bottom sheet
            const component = 'loginModal';

            if (isMobile) {
                $(document).trigger('openBottomSheetRequest', { targetId: '#' + component });
            }
            else {
                $('#modal' + component).modal('show');
            }

            //Removes frequeny select
            $frequencySelect.addClass('d-none');
        }
    }
    else {
        let addToCartOriginalButtonText = '';
        if (isMobile) {
            addToCartOriginalButtonText = $addToCartButton.data('original-text-mobile');
            resetRecurringPurchaseMobileLabel();
        }
        else {
            addToCartOriginalButtonText = $addToCartButton.data('original-text-desktop');
        }

        $addToCartButton.text(addToCartOriginalButtonText);
        $frequencySelect.addClass('d-none');
    }
}

/**
 * Updates the display based on the selected delivery method (shipping or locker).
 * Hides/shows elements in PDP accordingly and logs a message if no valid method is selected.
 */
function manageIncompatibleDeliveryMethodUI() {
    var recurringPurchaseSection = $('.recurring-purchase');
    var ffData = $('.delivery-data').data('fulfillment');

    // If no fulfillment data or incompatible delivery method, exit early
    if (!deliveryUtils.hasShippingMethod()) {
        return;
    }
    handleToggleAndUpdateUrlForRecurringDelivery(ffData);
    var $togglePurchase = recurringPurchaseSection.find('.toggle-purchase');
    var $incompMsg = recurringPurchaseSection.find('.recurring-incompatibility-message');

     // Set up click event handler for opening delivery modal
    $('.recurring-purchase-open-delivery-modal').on('click', function(event) {
        event.preventDefault();
        $(document).trigger("openDeliveryModalRequest", { redirectUrl: '' });
    });

    //Hide or show elements based on the selected method
    if (ffData.isShippingMethodLocker) {
        $togglePurchase.hide();
        $incompMsg.show();
    } else if (ffData.isShippingMethodDelivery) {
        $togglePurchase.show();
        $incompMsg.hide();
    }
}

/**
 * Handles toggling the recurring delivery option based on shipping method.
 * @param {Object} ffData - An object containing shipping information.
 * @param {boolean} selectRecurrentToggle - Decides if the toggle need to be selected.
 * Checks if 'selectRecurrentToggle' exists in the URL parameters and enables the recurring purchase checkbox.
 * Removes 'selectRecurrentToggle' from the URL and updates it using pushState without reloading the page.
 */
function handleToggleAndUpdateUrlForRecurringDelivery(ffData) {
    const url = new URL(window.location.href);
    const params = url.searchParams;

    if (ffData.isShippingMethodDelivery && params.get('selectRecurrentToggle')) {
            $('.recurring-purchase-checkbox').prop('checked', true).trigger('change');
    }

    params.delete('selectRecurrentToggle');

    // Update URL only if needed
    const newUrl = params.toString() ? `${url.pathname}?${params}` : url.pathname;
    if (newUrl !== window.location.href) {
        window.history.pushState({}, '', newUrl);
    }
}

function startRecurringPurchaseEvents() {
    $('body').on('change', '.recurring-purchase-checkbox', handleRecurringPurchaseToggle);
    $('.recurring-purchase .select-input').on('change', handleRecurringPurchaseSelection);
    manageIncompatibleDeliveryMethodUI();
}

function handleRecurringPurchaseButtonClicked(base){
    $('body').on('click', '.quick-buy-recurrent-product', function (e) {
        e.preventDefault();
        e.stopPropagation();
        base.createTemporaryBasket($(this));
    });
}

function useAsRecurrencePurchaseTrigger($buttonTextElement , recurrency){
    if (recurrency && $buttonTextElement) {
        $buttonTextElement
            .closest('button')
            .addClass('quick-buy-recurrent-product');
        $buttonTextElement.closest('button').removeClass('add-to-cart');
    } else if($buttonTextElement) {
        $buttonTextElement
            .closest('button')
            .removeClass('quick-buy-recurrent-product');
        $buttonTextElement.closest('button').addClass('add-to-cart');
    }
}

module.exports = {
    startRecurringPurchaseEvents,
    manageIncompatibleDeliveryMethodUI,
    handleRecurringPurchaseButtonClicked,
    useAsRecurrencePurchaseTrigger
}